import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from 'react-bootstrap/ProgressBar';
import FreePlayIcon from '../assets/FiveDollarFreePlayIcon.png';
import SapphireIcon from '../assets/SapphireIcon.png';
import './SapphireTracker.css';

export const FREE_PLAY_SAPPHIRE_COST = 50;
const LOWER_PATH_THRESHOLD = 0.5;
const MIDDLE_PATH_THRESHOLD = 0.8;
const UPPER_PATH_THRESHOLD = 1;

const SapphireTracker = ({
  remainingSapphiresToEarn,
  totalSapphiresToEarn
}) => {
  const totalSapphiresEarned = totalSapphiresToEarn - remainingSapphiresToEarn;
  let earnedSapphireRatio = totalSapphiresEarned / totalSapphiresToEarn;
  if (remainingSapphiresToEarn === 0 && totalSapphiresToEarn === 0) {
    earnedSapphireRatio = 1;
  }

  const freePlayGoalEnabled =
    totalSapphiresToEarn >= FREE_PLAY_SAPPHIRE_COST &&
    totalSapphiresEarned < FREE_PLAY_SAPPHIRE_COST;
  const freePlayCostRatio = FREE_PLAY_SAPPHIRE_COST / totalSapphiresToEarn;

  const renderSupportingText = () => {
    if (earnedSapphireRatio < LOWER_PATH_THRESHOLD) {
      return "You've still got plenty of Sapphires waiting to be discovered";
    } else if (
      earnedSapphireRatio >= LOWER_PATH_THRESHOLD &&
      earnedSapphireRatio < MIDDLE_PATH_THRESHOLD
    ) {
      return "You've uncovered half of your Sapphires. Keep playing to reveal the rest!";
    } else if (
      earnedSapphireRatio >= MIDDLE_PATH_THRESHOLD &&
      earnedSapphireRatio < UPPER_PATH_THRESHOLD
    ) {
      return "Great job! You've found nearly all of your Sapphires.";
    } else {
      return "You've discovered all of your Sapphires!";
    }
  };

  return (
    <div className="sapphire-tracker-container">
      <div className="title">Sapphire Tracker</div>
      <ProgressBar now={Math.floor(earnedSapphireRatio * 100)} />
      <div className="sapphire-icon-container">
        <img
          className="sapphire-icon"
          src={SapphireIcon}
          alt="Sapphire Progress"
          style={{
            left: `${Math.floor(earnedSapphireRatio * 100)}%`
          }}
        />
        {freePlayGoalEnabled && (
          <img
            className="free-play-icon"
            src={FreePlayIcon}
            alt="Free Play Goal"
            style={{
              left: `${Math.floor(freePlayCostRatio * 100)}%`
            }}
          />
        )}
      </div>
      <div className="supporting-text">{renderSupportingText()}</div>
    </div>
  );
};

SapphireTracker.propTypes = {
  remainingSapphiresToEarn: PropTypes.number,
  totalSapphiresToEarn: PropTypes.number
};

export default SapphireTracker;
